import './ExportStatusBadge.scss';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { StatusBadge } from '../../../../../../design/statusBadge/StatusBadge';
import { ProjectExportStatus } from '../../models/ProjectExport';

interface IProps {
  status: ProjectExportStatus;
}

export const ExportStatusBadge = ({ status }: IProps): ReactElement => {
  const { t } = useTranslator();

  const getText = (): string => {
    switch (status) {
      case ProjectExportStatus.Failed:
        return t('export_status.failed');
      case ProjectExportStatus.Finished:
        return t('export_status.finished');
      case (ProjectExportStatus.New, ProjectExportStatus.InProgress):
        return t('export_status.running');
      case ProjectExportStatus.None:
      case ProjectExportStatus.New:
      default:
        return t('export_status.unknown');
    }
  };

  return (
    <StatusBadge
      className={classNames('export-status-badge', status.toLowerCase())}
      text={getText()}
    />
  );
};
